import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { Alert, AlertDescription } from '@components/ui/alert';
import { Button } from '@components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@components/ui/dialog';
import { Input } from '@components/ui/input';
import { TenantCorporateContext } from '..';
import { links } from '../../core/router';

interface DeleteModalProps {
    open?: boolean;
    onModalClose?(): void;
}

export const DeleteModal = ({
    open: initialOpen = false,
    onModalClose
}: DeleteModalProps) => {
    const [open, setOpen] = React.useState(initialOpen);
    const [tenantField, setTenantField] = React.useState('');
    const corporateClient = React.useContext(TenantCorporateContext);
    const { tenantName } = useParams();
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
        onModalClose?.();
    };
    React.useEffect(() => {
        setOpen(initialOpen);
    }, [initialOpen]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTenantField(event.target.value);
    };

    const handleDelete = async () => {
        try {
            await corporateClient.support.tenantSupportControllerDeleteTenant(
                tenantName
            );
            navigate(links.tenants());
        } catch (error) {
            handleClose();
        }
    };
    return (
        <Dialog open={open} onOpenChange={(next) => !next && handleClose()}>
            <DialogContent className="sm:max-w-lg">
                <DialogHeader>
                    <DialogTitle>Are you absolutely sure?</DialogTitle>
                </DialogHeader>
                <Alert variant="warning">
                    <AlertDescription>
                        Unexpected bad things will happen if you don’t read
                        this!
                    </AlertDescription>
                </Alert>
                <p className="text-sm">
                    This action cannot be undone. This will permanently delete
                    the <strong>{tenantName}</strong> tenant, users, employees,
                    payout runs etc.
                </p>
                <p className="text-sm">
                    Please type <strong>{tenantName}</strong> to confirm.
                </p>
                <Input
                    type="text"
                    required
                    value={tenantField}
                    onChange={handleChange}
                />
                <DialogFooter>
                    <Button
                        className="w-full"
                        onClick={handleDelete}
                        variant="destructive"
                        disabled={tenantField !== tenantName}
                    >
                        Delete
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
